import React from 'react';
import PropTypes from 'prop-types';
import NotificationsItem from '../NotificationItem/NotificationItem';
import styles from './NotificationRequestSubmitted.scss';

const NotificationRequestSubmitted = ({
  notification,
  close,
  action,
  notificationData,
  staticTexts,
  onClickMarkAsRead,
}) =>
  <NotificationsItem
    notification={notification}
    close={close}
    action={action}
    notificationData={notificationData}
    staticTexts={staticTexts}
    onClickMarkAsRead={onClickMarkAsRead}
  >
    <div className={styles.messageQuestion}>
      <span className={styles.requestStatus}>{`${notification.data.author} `}</span>
      {notificationData.requestSubmitted.staticText}
    </div>
  </NotificationsItem>;

NotificationRequestSubmitted.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.string,
    type: PropTypes.string,
    seen: PropTypes.bool,
    data: PropTypes.object,
  }).isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  notificationData: PropTypes.shape({
    requestSubmitted: PropTypes.shape({
        staticText: PropTypes.string
    })
  }).isRequired,
  staticTexts: PropTypes.shape({
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
  }).isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
};

export default NotificationRequestSubmitted;
